// @flow
import React, { Component } from 'react';
import { reduxForm, Field, type FormSubmitHandler } from 'redux-form';
import {
  BasicInfoFormCard,
  BasicInfoFormForm,
  BasicInfoFormFieldDiv
} from './InformationStyles';
import SubmitButton from '../../../components/SubmitButton';
import { Device } from '../../../components/Responsive';
import { defaultSubmitHandler } from '../../../utilities/requests';
import Input from '../../../components/Input';
import {
  requiredField,
  passwordValidation,
  passwordConfirm
} from '../../../utilities/validations';
import { showSuccessModal } from '../../../modules/ModalConductor/reducer';

type Props = {
  toggleEdit: () => void,
  submitting: boolean,
  error: string,
  handleSubmit: FormSubmitHandler
};

class BasicInfoForm extends Component<Props> {
  handleClose = () => {
    this.props.toggleEdit();
  };

  handleSave = () => {
    this.props.handleSubmit();
  };

  render() {
    return (
      <BasicInfoFormCard
        close
        save
        submitting={this.props.submitting}
        error={this.props.error}
        handleClose={this.handleClose}
        handleSave={this.handleSave}
      >
        <BasicInfoFormForm onSubmit={this.props.handleSubmit}>
          <BasicInfoFormFieldDiv>
            <Field
              name="current_password"
              label="Current Password"
              type="password"
              component={Input}
              validate={requiredField}
            />
            <Field
              name="password"
              label="New Password"
              type="password"
              component={Input}
              validate={passwordValidation}
            />
            <Field
              name="password_confirmation"
              label="Confirm Password"
              type="password"
              component={Input}
              validate={passwordConfirm}
            />
          </BasicInfoFormFieldDiv>
          <Device>
            <SubmitButton
              value="SAVE"
              disabled={this.props.submitting}
              error={this.props.error}
              marginTop="4rem"
            />
          </Device>
        </BasicInfoFormForm>
      </BasicInfoFormCard>
    );
  }
}

const onSubmitSuccess = (result, dispatch, props) => {
  props.toggleEdit();
  dispatch(
    showSuccessModal(
      'Password updated',
      'Your password has been updated successfully. Please use your new password next time you sign in.'
    )
  );
};

export default reduxForm({
  form: 'basicInfo',
  onSubmit: defaultSubmitHandler('/partners', 'patch'),
  onSubmitSuccess
})(BasicInfoForm);
